<template>
  <svg
    width="20px"
    height="18px"
    viewBox="0 0 20 18"
    version="1.1"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        class="symbol"
        transform="translate(-1283.000000, -134.000000)"
        fill-rule="nonzero"
      >
        <path
          d="M1303,142.993902 L1294.68838,134 L1294.68838,139.365925 L1292.92126,139.365925 C1287.44183,139.365925 1283,143.749191 1283,149.156373 L1283,152 L1283.78491,151.151203 C1286.45352,148.265867 1290.22946,146.621879 1294.1882,146.621879 L1294.68838,146.621879 L1294.68838,151.987803 L1303,142.993902 Z"
          id="Path-Copy"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgIconShare'
}
</script>


// WEBPACK FOOTER //
// src/js/svgs/SvgIconShare.vue